module.exports = __webpack_public_path__ + "static/media/demonstrative_adjectives_img.af03fbff.JPG";